import React from 'react';

/** 전화문의 버튼 안에 들어가는 안내 문구 (button 내부라 p 대신 span 사용) */
const PhoneInquiryNotice = () => {
  return (
    <>
      <span className="block bg-brown-1 text-brown-0 rounded-[10px] px-3 py-[10px] font-medium text-center break-keep text-[14px] leading-[20px] sm280:text-[13px] sm280:leading-[18px]">
        전화 문의 시 안전한 거래를 위해 통화 내용이 <span className="font-bold">녹취됩니다.</span>
      </span>
      <span className="block mt-2 text-grey-6 text-center break-keep text-[13px] leading-[18px] sm280:text-[12px] sm280:leading-[16px]">
        판매자의 개인정보 보호를 위해 050 안심번호로 변경됩니다.
      </span>
    </>
  );
};

export default PhoneInquiryNotice;
